export default "__VITE_ASSET__CIo7RZum__"